/**
 * Created by yanguoxu on 16/7/26.
 */
import token from 'token'

function plugin() {
    if ($) {
        function csrfSafeMethod(method) {
            // these HTTP methods do not require CSRF protection
            return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
        }

        $(document).on('ajaxBeforeSend', function (e, xhr, settings){
            //console.log("heelo");
            if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
                xhr.setRequestHeader("X-CSRFToken", token());
            }
        });
    }
}

export default plugin



// WEBPACK FOOTER //
// ./src/util/zepto-http.js